import React from 'react'

const GitCommitHash: React.FC = () => {
  return <span style={{ fontFamily: 'monospace' }}>[{process.env['REACT_APP_COMMIT_SHA_SHORT'] || 'n/a'}]</span>
}

export default GitCommitHash
